import React, { Component } from 'react';
import { connect } from 'react-redux';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import { startLogin } from '../../actions/authActions';

export class LoginPage extends Component {

  state = {
    //status
    email: '',
    password: ''
  }


  onSubmit = e => {
    const { email, password } = this.state;
    e.preventDefault();
    this.props.startLogin(email, password);
  }

  onFormChange = e => {
    const key = e.target.name;
    const value = e.target.value;
    this.setState({ [key]: value });
  };

  render() {
    const { email, password } = this.state;
    return (
      <form noValidate autoComplete="off" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <div>
        <TextField
          autoFocus
          required
          label="Email"
          name="email"
          value={email}
          onChange={this.onFormChange}
          margin="normal"
        />
      <br/>
        <TextField
          required
          type="password"
          id="password-input"
          label="Password"
          name="password"
          value={password}
          onChange={this.onFormChange}
          margin="normal"
        />
        <Typography variant="caption" gutterBottom align="center">
          {this.props.errMessage}
        </Typography>
        <br/>
        <Button variant="raised" color="primary" onClick={this.onSubmit} style={{ alignSelf: 'center'}}>
          Login
        </Button>

        </div>
      </form>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  startLogin: (email, password) => dispatch(startLogin(email, password))
});


const mapStateToProps = ({ errors }) => {
  const { errMessage } = errors;
  return { errMessage };
};

export default connect(mapStateToProps, mapDispatchToProps)(LoginPage);



// WEBPACK FOOTER //
// ./src/components/auth/LoginPage.js